import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
import { useIntersection } from 'react-use';
import useThrottledWindowScrollPosition from 'hooks/useThrottledWindowScrollPosition';
import setStickyButtonHeightCssVar from 'commons/setStickyButtonHeightCssVar';
import useScreen from 'hooks/useScreen';
const useShowStickyButtons = addToBagSectionRef => {
  const $ = _c(9);
  const {
    isMobileOrTablet
  } = useScreen();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const intersection = useIntersection(addToBagSectionRef, t0);
  const isIntersecting = intersection?.isIntersecting;
  const [scrollPositionY, setScrollPositionY] = useState(0);
  const [showStickyButtons, setShowStickyButtons] = useState(false);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = t2 => {
      const {
        y
      } = t2;
      setScrollPositionY(y);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onThrottledWindowScrollPositionChange = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      callback: onThrottledWindowScrollPositionChange
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useThrottledWindowScrollPosition(t2);
  let t3;
  let t4;
  if ($[3] !== addToBagSectionRef || $[4] !== isIntersecting || $[5] !== isMobileOrTablet || $[6] !== scrollPositionY) {
    t3 = () => {
      if (addToBagSectionRef.current) {
        const {
          offsetTop: topOfAddToBagFromViewport
        } = addToBagSectionRef.current;
        if (!isIntersecting && scrollPositionY > topOfAddToBagFromViewport) {
          setShowStickyButtons(true);
          if (isMobileOrTablet) {
            setStickyButtonHeightCssVar(100);
          }
        } else {
          setShowStickyButtons(false);
          if (isMobileOrTablet) {
            setStickyButtonHeightCssVar(11);
          }
        }
      }
    };
    t4 = [isIntersecting, scrollPositionY, addToBagSectionRef, isMobileOrTablet];
    $[3] = addToBagSectionRef;
    $[4] = isIntersecting;
    $[5] = isMobileOrTablet;
    $[6] = scrollPositionY;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useEffect(t3, t4);
  return showStickyButtons;
};
export default useShowStickyButtons;